// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-m_fQ","advertDetailContacts__header":"c-m_fR"};